import { getDay, isValid, parse, startOfDay } from 'date-fns';
import { RuleProps } from '../../../types/application.d';

export const APPLICATION_SUBMISSION = 'app-submission';
export const ADDITIONAL_INFORMATION = 'additional-information';

export const APPLICATION_SUBMISSION_FIELDS = [
    {
        sectionID: APPLICATION_SUBMISSION,
        sectionName: '',
        fieldList: [
            {
                id: 'tentative-rating',
                label: 'Tentative Rating',
                type: 'text',
                rule: {
                    required: true,
                    hidden: true
                }
            },
            {
                id: 'format',
                label: 'Format',
                type: 'dropdown',
                apiID: 'FormatsAvailable',
                hasLabelInfo: true,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    required: true,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General');
                        return result;
                    }
                }
            },
            {
                id: 'online-link',
                label: 'Online Link',
                type: 'url',
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] !== 'Online Link');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'id-username',
                label: 'ID/Username',
                type: 'text',
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'password',
                label: 'Password',
                type: 'text',
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'dateCombo',
                label: 'Preferred Date of Media Submission',
                type: 'dateRadio',
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] !== 'Physical');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Physical');
                        return result;
                    }
                },
                preField: {
                    id: 'radio-day',
                    label: ' ',
                    type: 'radio',
                    options: [
                        {
                            optID: 'AM',
                            optLabel: 'AM'
                        },
                        {
                            optID: 'PM',
                            optLabel: 'PM'
                        }
                        // {
                        //     optID: 'Full Day',
                        //     optLabel: 'Full Day'
                        // }
                    ]
                },
                mainField: {
                    id: 'main',
                    type: 'date2',
                    rule: {
                        baseIds: [`${APPLICATION_SUBMISSION}-format`],
                        required: ({ baseValues }: RuleProps) => {
                            const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] !== 'Physical');
                            return result;
                        },
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Physical');
                            return result;
                        },
                        dateLimit: () => {
                            return { minDate: new Date() };
                        },
                        customValidate: ({ currentValue }: RuleProps) => {
                            if (!currentValue) return;

                            const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                            if (!isValid(selectedDate)) return 'Invalid Date';

                            const today = startOfDay(new Date());

                            if (selectedDate < today) {
                                return 'Must select current date or future date';
                            }

                            const day = getDay(selectedDate);
                            if (day === 0 || day === 6) {
                                return 'Weekend dates are not allowed';
                            }
                        },
                        disabledWeekend: true
                    }
                }
            },
            {
                id: 'attachments',
                label: 'Attachment Upload',
                type: 'file',
                category: 'SupportingDocuments',
                fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    // 'text/plain',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    // 'image/gif',
                    'image/bmp',
                    'video/quicktime',
                    'video/mp4',
                    'video/mpeg'
                ],
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General');
                        return result;
                    }
                }
            },
            {
                id: 'do-you-need-express',
                type: 'label',
                variant: 'h4',
                label: 'Do you need Express Service?',
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General' ||
                                baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Advisory 16')
                        );
                        return result;
                    },
                    previewHidden: true
                }
            },
            {
                id: 'do-you-need-express-body',
                type: 'label',
                label: '',
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General' ||
                                baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Advisory 16')
                        );
                        return result;
                    },
                    previewHidden: true
                }
            },
            {
                id: 'id-type',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes, classification fee of $200 applies if the game is rated M18, Refused Classification or Prohibited'
                    },
                    {
                        optID: 'No',
                        optLabel: `No, classification fee of $50 applies if the game is rated M18, Refused Classification or Prohibited`
                    }
                ],
                isRowDisplay: true,
                type: 'radio',
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    required: true,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General' ||
                                baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Advisory 16')
                        );
                        return result;
                    },
                    previewHidden: true
                }
            }
        ]
    }
];

export const ADDITIONAL_INFORMATION_FIELDS = [
    {
        sectionID: ADDITIONAL_INFORMATION,
        sectionName: '',
        fieldList: [
            {
                id: 'remarks-to-applicant',
                label: 'Remarks to Applicant',
                type: 'longText',
                textRows: 4,
                span: 12,
                placeholder: ' ',
                rule: {
                    readOnly: true
                }
            },
            {
                id: 'tentative-rating',
                label: 'Tentative Rating',
                type: 'text',
                rule: {
                    required: true,
                    hidden: true
                }
            },
            {
                id: 'format',
                label: 'Format of Submission of Additional Information',
                type: 'dropdown',
                apiID: 'FormatsAvailable',
                hasLabelInfo: true,
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_INFORMATION}-tentative-rating`],
                    required: true,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-tentative-rating`] === 'General');
                        return result;
                    }
                }
            },
            {
                id: 'online-link',
                label: 'Online Link',
                type: 'url',
                rule: {
                    baseIds: [`${ADDITIONAL_INFORMATION}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] !== 'Online Link');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'id-username',
                label: 'ID/Username',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_INFORMATION}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'password',
                label: 'Password',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_INFORMATION}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'dateCombo',
                label: 'Preferred Date and Time of Media Submission',
                type: 'dateRadio',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_INFORMATION}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] !== 'Physical');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] === 'Physical');
                        return result;
                    }
                },
                preField: {
                    id: 'radio-day',
                    label: ' ',
                    type: 'radio',
                    options: [
                        {
                            optID: 'AM',
                            optLabel: 'AM'
                        },
                        {
                            optID: 'PM',
                            optLabel: 'PM'
                        }
                        // {
                        //     optID: 'Full Day',
                        //     optLabel: 'Full Day'
                        // }
                    ]
                },
                mainField: {
                    id: 'main',
                    type: 'date2',
                    rule: {
                        baseIds: [`${ADDITIONAL_INFORMATION}-format`],
                        required: ({ baseValues }: RuleProps) => {
                            const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] !== 'Physical');
                            return result;
                        },
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = !Boolean(baseValues && baseValues[`${ADDITIONAL_INFORMATION}-format`] === 'Physical');
                            return result;
                        },
                        dateLimit: () => {
                            return { minDate: new Date() };
                        },
                        customValidate: ({ currentValue }: RuleProps) => {
                            if (!currentValue) return;

                            const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                            if (!isValid(selectedDate)) return 'Invalid Date';

                            const today = startOfDay(new Date());

                            if (selectedDate < today) {
                                return 'Must select current date or future date';
                            }

                            const day = getDay(selectedDate);
                            if (day === 0 || day === 6) {
                                return 'Weekend dates are not allowed';
                            }
                        },
                        disabledWeekend: true
                    }
                }
            },
            {
                id: 'third-party-body',
                type: 'label',
                label: '',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_INFORMATION}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && !(baseValues[`${ADDITIONAL_INFORMATION}-format`] === 'Third-Party Online File Delivery')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'longText',
                textRows: 4,
                span: 12
            }
        ]
    }
];
